var map = {
	"./light/logo/favicon": 313,
	"./light/logo/favicon.png": 313,
	"./light/logo/logo": 314,
	"./light/logo/logo-on-white": 315,
	"./light/logo/logo-on-white.png": 315,
	"./light/logo/logo-square-bg": 316,
	"./light/logo/logo-square-bg.png": 316,
	"./light/logo/logo.png": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;